/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { IncludedResource, SubscriptionSchedule } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class SubscriptionSchedules<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags subscription_schedules
   * @name GetSubscriptionSchedules
   * @summary 指定された商品の定期便発送スケジュールを返す
   * @request GET:/subscription_schedules
   */
  getSubscriptionSchedules = (
    query?: {
      /**
       * 返すスケジュールの最大数
       * @default "8"
       */
      limit?: string;
      /**
       * 配送先の郵便番号
       * @default null
       */
      postal_code?: string;
      /**
       * 先のスケジュールを返すか
       * @default "1"
       */
      upcoming?: "1" | "0";
      /**
       * 画像があるもののみを返すか
       * @default "0"
       */
      with_image?: "1" | "0";
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: SubscriptionSchedule[];
        included?: IncludedResource[];
      },
      void
    >({
      path: `/subscription_schedules`,
      method: "GET",
      query: query,
      type: ContentType.UrlEncoded,
      ...params,
    });
}
